import '../../Player.css';

import React,{ useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import EmailIcon from '@mui/icons-material/Email';
import ShareIcon from '@mui/icons-material/Share';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { PlayerContext } from '../../PlayerContext';
import DialogContainer from '../components/DialogContainer';
import {isChromeOnMacOS, isAndroid, isInstagramInAppBrowser, closeFullscreen } from '../../Utils';
import { buildStoryShareLink } from '../../chainRestaurantUtils';
import {Image} from 'react-native';
import { useAnimate } from 'framer-motion';

function ShareDialog(props){
    const { t } = useTranslation();
    const { onClose, opened } = props;
    const storyDimensions = useContext(PlayerContext).get("storyDimensions");
    const sizeMultiplier = useContext(PlayerContext).get("sizeMultiplier");  
    const [showOtherWays, setShowOtherWays] = useState(false);
    const fromDemo = useContext(PlayerContext).get("fromDemo");
    const idPrefix = fromDemo ? (fromDemo +"-") : "";

    const [scope, animate] = useAnimate();

    useEffect(() => {
        if (opened){   
                  
            const galleryOverlay = document.getElementById(idPrefix+"dialog-background");
            if (galleryOverlay != null){                                  
                const animation = async () => {                       
                    animate(galleryOverlay, { opacity: 1}, {duration: 0.3});                    
                }
                
                animation();
            }                        
        }
    }, [opened]);

    function shareRestaurantName() {
        if (!props.story?.posName) {
            return t("ShareTextDefaultName");
        }
        return props.story.posName !== "Holberton School Paris" ? props.story.posName : "Holberton School";
    }

    function getShareLink() {
        return buildStoryShareLink(props.story);
    }

    function sendEmail(){
        const mailto = "mailto:" + "?subject=" + t("ShareTitle") + "&body=" + t("ShareText", {name: shareRestaurantName()}) + " " + getShareLink()/* + "?utm_source=upreality&utm_medium=share"*/;    
        
        if (isChromeOnMacOS()){
            window.open(mailto, '_blank');
        }
        else {
            window.location.href = mailto;
        }
        onClose(false);
    }

    function shareOnFacebook(){
        
        const link = "https://www.facebook.com/dialog/share?app_id=407849446609669&display=popup&href=" + encodeURI(getShareLink());

        if (isChromeOnMacOS()){
            window.open(link, '_blank');
        }
        else {
            window.location.href = link;
        }    
        onClose(false);
    }

    function copyToClipboard(){
        let shareText = t("ShareTitle") + "\n\n" + t("ShareText", {name: shareRestaurantName()}) + "\n\n" + getShareLink()/* + "?utm_source=upreality&utm_medium=share"*/;
        navigator.clipboard.writeText(shareText);
        onClose(true);
    }

    const sm = sizeMultiplier || 1;
    const iconSize = 24 * sm;
    const iconMarginLeft = 8 * sm;
    const listIconMinWidth = 40 * sm;
    const itemFontSize = 16 * sm;
    const titleFontSize = 20 * sm;
    const otherShareW = 179 * sm;
    const otherShareH = 170 * sm;

    return (<>
                {showOtherWays && <Image source="/images/other_share.png" onClick={() => {setShowOtherWays(false);}} style={{position: "absolute", top: 0, left: storyDimensions.containerWidth - otherShareW, width: otherShareW, height: otherShareH, zIndex: 200}}/>}
                {<DialogContainer opened={opened} onClose={()=>{onClose();}} storyId={props.storyId} style={{opacity: 0}}>
                    <div onClick={(e)=>e.stopPropagation()}>
                    <DialogTitle style={{
                        userSelect: 'none',
                        WebkitUserSelect: 'none',
                        width: 240 * sm,
                        fontSize: titleFontSize,
                        lineHeight: 1.25,
                        paddingTop: 16 * sm,
                        paddingBottom: 8 * sm,
                        paddingLeft: 24 * sm,
                        paddingRight: 24 * sm,
                    }}>{t("ShareDialogTitle")}&nbsp;{t('ShareEmoji')}</DialogTitle>
                        <List dense={sm < 1} disablePadding={sm < 1}>
                            <ListItemButton onClick={() => sendEmail()} key={"share_email"} style={{ paddingTop: 8 * sm, paddingBottom: 8 * sm, paddingLeft: 16 * sm, paddingRight: 16 * sm }}>
                                <ListItemIcon style={{ minWidth: listIconMinWidth }}>
                                    <EmailIcon className="booking-option" style={{marginLeft: iconMarginLeft, width: iconSize, height: iconSize }} />
                                </ListItemIcon>
                                <ListItemText className="booking-option" primary={t('ShareEmail')} primaryTypographyProps={{ fontSize: itemFontSize }} />
                            </ListItemButton>    
                            <ListItemButton onClick={() => shareOnFacebook()} key={"share_facebook"} style={{ paddingTop: 8 * sm, paddingBottom: 8 * sm, paddingLeft: 16 * sm, paddingRight: 16 * sm }}>
                                <ListItemIcon style={{ minWidth: listIconMinWidth }}>
                                    <ShareIcon className="booking-option" style={{marginLeft: iconMarginLeft, width: iconSize, height: iconSize }} />
                                </ListItemIcon>
                                <ListItemText className="booking-option" primary={t('ShareFacebook')} primaryTypographyProps={{ fontSize: itemFontSize }} />
                            </ListItemButton>  
                            <ListItemButton onClick={() =>{copyToClipboard()}} key={"share_clipboard"} style={{ paddingTop: 8 * sm, paddingBottom: 8 * sm, paddingLeft: 16 * sm, paddingRight: 16 * sm }}>
                                <ListItemIcon style={{ minWidth: listIconMinWidth }}>
                                    <ContentCopyIcon className="booking-option" style={{marginLeft: iconMarginLeft, width: iconSize, height: iconSize }} />
                                </ListItemIcon>
                                <ListItemText className="booking-option" primary={t('ShareCopy')} primaryTypographyProps={{ fontSize: itemFontSize }} />
                            </ListItemButton> 

                            {isAndroid() && isInstagramInAppBrowser() && <ListItemButton onClick={() => {setShowOtherWays(true);closeFullscreen();}} key={"share_others"} style={{ paddingTop: 8 * sm, paddingBottom: 8 * sm, paddingLeft: 16 * sm, paddingRight: 16 * sm }}>
                                <ListItemIcon style={{ minWidth: listIconMinWidth }}>
                                    <MoreVertIcon className="booking-option" style={{marginLeft: iconMarginLeft, width: iconSize, height: iconSize }} />
                                </ListItemIcon>
                                <ListItemText className="booking-option" primary={t('ShareOther')} primaryTypographyProps={{ fontSize: itemFontSize }} />
                            </ListItemButton>    }
                        </List>
                    </div>
                </DialogContainer> 
                }  
        </>      
    );
}

export default ShareDialog;